
<script>
import Vue from 'vue'
// 新建一个文件,new 一个 vue 实例导出
export default new Vue({
  name: 'eventBus',
  data () {
    return {
    }
  }
})
</script>


// WEBPACK FOOTER //
// index.vue?47245854